import API from './API';

export default class FrequencyAPI extends API {
  constructor(parameters = {}) {
    super('/Frequency', parameters);
  }

  getLeaseFrequency() {
    return this.submit("get", `${this.endpoint}/GetLeaseFrequency`);
  }
}
